import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

// Import helpers
import { API_ERRORS } from 'helpers/error_code_api';
import { checkPlayerType } from 'helpers';

// Import components
import ParentalControlButton from '../ParentalControlButton';
import Packets from 'components/elements/molecules/player/Packets';

const {
	BLOCKED_BY_PARENTAL_CONTROL,
	RESOURCE_NOT_IN_SUBSCRIBER_PRODUCTS
} = API_ERRORS;

const PlayerErrorContent = ({ errorCode, playerType, message }) => {
	const { pathname } = useLocation();
	const type = playerType || checkPlayerType(pathname);

	switch (errorCode) {
		case BLOCKED_BY_PARENTAL_CONTROL:
			return <ParentalControlButton playerType={type} />;

		case RESOURCE_NOT_IN_SUBSCRIBER_PRODUCTS:
			return <Packets playerType={type} message={message} />;

		default:
			return null;
	}
};

PlayerErrorContent.propTypes = {
	errorCode: PropTypes.string.isRequired,
	playerType: PropTypes.string,
	message: PropTypes.string
};

export default PlayerErrorContent;
